// extracted by mini-css-extract-plugin
export var container = "_hl-0";
export var dotAnimation = "_hl-2";
export var dotsLoading = "_hl-1";